import { render, staticRenderFns } from "./ParagraphStructureTreeBox.vue?vue&type=template&id=6375c323&"
import script from "./ParagraphStructureTreeBox.vue?vue&type=script&lang=js&"
export * from "./ParagraphStructureTreeBox.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphStructureTreeBox.vue?vue&type=style&index=0&id=6375c323&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports